import { ReduxToolkit } from "../utils/utilities";
import { BudgetStore } from "./budget-store";
import { ProaStore } from "./proa-store";
import { SessionStore } from "./session-store";
import { SPFRRStore } from "./spfrr-store";
import { FollowupStore } from "./followup-store";
import { PopStore } from "./pop-store";

const sessionStore = new SessionStore();
const budgetStore = new BudgetStore();
const proaStore = new ProaStore();
const spfrrStore = new SPFRRStore();
const followupStore = new FollowupStore();
const popStore = new PopStore();

export const store = ReduxToolkit.configureStore({
    reducer: {
      session: sessionStore.reducer,
      budget: budgetStore.reducer,
      proa : proaStore.reducer,
      spfrr: spfrrStore.reducer,
      followup : followupStore.reducer,
      pop : popStore.reducer,
    },
    middleware: ReduxToolkit.getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false
    }),
    devTools:true
  });
  
  export type RootState = ReturnType<typeof store.getState>;
  export type AppThunk<ReturnType = any> = ReduxToolkit.ThunkAction<
    ReturnType,
    RootState,
    unknown,
    ReduxToolkit.Action<any>
  >;

